import { createContext } from 'react'

import initValue from './initValue'

const AppContext = createContext({
  context: initValue,
  setContext: {},
})

export default AppContext
